module.exports = __webpack_public_path__ + "img/digital-menuboards.73854d12.png";